export const ASSET_NOT_FOUND = 'ylandsApiService.assetNotFound';
export const ASSET_BLOCKED = 'ylandsApiService.assetBlocked';
export const PROFILE_NOT_FOUND = 'ylandsApiService.profileNotFound';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const SPACE_EXCEEDED = 'spaceExceeded';
export const STORAGE_SPACE_QUOUTA_EXCEEDED =
    'storageApiService.exceededSpaceQuota';
